import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import IndustriesView from '../views/IndustriesView.vue'
import ProjectsView from '../views/ProjectsView.vue'
import LanguagesView from '../views/LanguagesView.vue'
import ContactView from '../views/ContactView.vue'
import AboutView from '../views/AboutView.vue'
import SoftwareView from '../views/SoftwareView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/industries',
    name: 'industries',
    component: IndustriesView
  },
  {
    path: '/projects',
    name: 'projects',
    component: ProjectsView
  },
  {
    path: '/Languages',
    name: 'languages',
    component: LanguagesView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/software',
    name: 'software',
    component: SoftwareView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
    // // route level code-splitting
    // // this generates a separate chunk (about.[hash].js) for this route
    // // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
